import React from "react";
import TableBase from "./Base";
import { DateTimeFormat } from "../../helpers/utils";

const NotificationsTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	stores,
	...props
}) => {
	const handleDisplayStores = (storesValue) => {
		const result = [];
		storesValue?.forEach((item) => {
			stores?.forEach((item2) => {
				if (item2.id === item) {
					result.push(item2.name);
				}
			});
		});
		return result?.join(", ");
	};

	const COLUMNS = [
		{
			title: "Title",
			dataIndex: "title",
			width: 200,
			ellipsis: true,
		},
		{
			title: "Target Group",
			dataIndex: "target_group",
			width: 150,
			ellipsis: true,
			render(value) {
				return <span className="text-capitalize">{value}</span>;
			},
		},
		{
			title: "Path to",
			width: 150,
			ellipsis: true,
			children: [
				{
					title: "Screen",
					key: "screen",
					width: 150,
					render(record) {
						return (
							<span className="text-capitalize">{record.path_to.screen}</span>
						);
					},
				},
				{
					title: "ID",
					key: "path_to_id",
					width: 150,
					render(record) {
						return <span>{record.path_to.id}</span>;
					},
				},
			],
		},
		{
			title: "Type",
			dataIndex: "type",
			width: 100,
			ellipsis: true,
			render(value) {
				return <span className="text-capitalize">{value}</span>;
			},
		},
		{
			title: "Send At",
			dataIndex: "send_at",
			width: 200,
			ellipsis: true,
			render(value, record) {
				return value && record.type === "general"
					? DateTimeFormat(value)
					: null;
			},
		},
		{
			title: "Start Time",
			dataIndex: "start_time",
			width: 200,
			ellipsis: true,
			render(value, record) {
				return value && record?.type === "store" ? DateTimeFormat(value) : null;
			},
		},
		{
			title: "End Time",
			dataIndex: "end_time",
			width: 200,
			ellipsis: true,
			render(value, record) {
				return value && record?.type === "store" ? DateTimeFormat(value) : null;
			},
		},
		{
			title: "Store IDs",
			dataIndex: "store_ids",
			width: 200,
			render(stores) {
				return handleDisplayStores(stores);
			},
		},
		{
			title: "Idle Time",
			dataIndex: "idle_period",
			width: 100,
			render(value, record) {
				return value && record?.type === "store" ? value : null;
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default NotificationsTable;
